import SitePage from './container';

export default SitePage;